module.exports = __webpack_public_path__ + "img/sub26.50955b9f.jpg";